const types = {
  USER: 'users',
  RECOVERY_CODE: 'recoveryCodes',

  COMPANY: 'companies',

  EMPLOYEE: 'employeeSummaries',
  EMPLOYMENT_RECORD: 'employmentRecords',
  TERMINATION_RECORD: 'terminationRecords',
  REACTIVATION_RECORD: 'reactivationRecords',
  ON_LEAVE_RECORD: 'onLeaveRecords',
  EMPLOYEE_DETAILS: 'employees',
  EMPLOYEE_PLATFORM_USAGE: 'employeePlatformUsages',
  VISIBILITY_SETTING: 'visibilitySettings',

  PERFORMANCE: {
    CHECKIN: 'performanceManagementCheckins',
    CHECKIN_RELATIONS: 'checkinRelations',
    CYCLE: 'performanceManagementCycles'
  },

  TASK: 'tasks',

  TASK_TEMPLATE: 'taskTemplates',

  TRAINING: {
    PROGRAM: 'trainingPrograms',
    EMPLOYEE_TRAINING_STATUS: 'trainingEmployeeTrainingStatuses',
    EMPLOYEE_TRAINING_STATUS_SUMMARY: 'trainingEmployeeTrainingStatusSummaries'
  },

  RECRUITING: {
    CANDIDATE: 'candidates',
    CANDIDATE_SUMMARY: 'candidateSummaries',
    POSITION: 'positions',
    POSITION_RULE: 'positionRule',
    JOB_SITE: {
      SETTING: 'jobSiteSettings',
      INVALID_INDEED_LOCATION: 'invalidIndeedLocations'
    },
    CANDIDATE_TAG: 'candidateTags',
    TIMELINE: {
      FEEDBACK: 'feedback',
      STAGE_CHANGE: 'stageChanges',
      EMAIL: 'emails',
      POSITION_CHANGE: 'positionChanges',
      UPLOAD: 'candidateInternalUploads',
      QUALIFICATION_STATUS_CHANGE: 'qualificationStatusChanges',
      OFFER: 'offerActions',
      RATING: 'candidateRating',
      INTERVIEW_GUIDE_RESPONSE: 'interviewGuideResponses',
      INTERVIEW_INVITE_ACTION: 'interviewInviteActions'
    }
  },

  DEPARTMENT: 'departments',

  FOLDER: 'folders',

  COMPANY_EMAIL_TEMPLATE: 'companyEmailTemplates',

  LOCATION: 'locations',

  SECURE_FILE: 'secureFiles',

  TAX_FORM_TEMPLATE: 'taxFormTemplates',

  COMPANY_LINK: 'companyLinks',
  COMPANY_FILE: 'companyFiles',
  COMPANY_FILE_FOLDER: 'companyFileFolders',

  CUSTOM_FIELD: 'customFields',
  CUSTOM_FIELD_GROUP: 'customFieldGroups',
  EMPLOYEE_CUSTOM_FIELD: 'employeeCustomFields',

  TIME_OFF: {
    POLICY: 'timeOffPolicies',
    POLICY_SUMMARY: 'timeOffPolicySummaries',
    TYPE_POLICY: 'typePolicies',
    ACCOUNT: 'timeOffAccounts',
    REQUEST: 'timeOffRequests',
    TRANSACTION: 'timeOffTransactions',
    ASSIGNMENT: 'timeOffRequestAssignments',
    TYPE: 'timeOffTypes',
    ACCOUNT_SUMMARY: 'timeOffAccountSummaries',
    TYPE_POLICY_CONFIRMATION_SUMMARY: 'typePolicyConfirmationSummaries',
    CONFLICT: 'timeOffConflicts',
    REQUEST_FORECAST: 'timeOffRequestForecasts',
    POLICY_CHANGE_FORECAST: 'timeOffPolicyChangeForecasts',
    ABSENCE: 'timeOffAbsences',
    BLOCKED_DATES: 'timeOffBlockedDates',
    LIABILITY_BALANCE: 'timeOffLiabilityBalances'
  },

  TIME_TRACKING: {
    POLICY: 'timeTrackingPolicies',
    SCHEDULE: 'timeTrackingSchedules',
    DIMENSION: 'timeTrackingDimensions',
    DIMENSION_VALUE: 'timeTrackingDimensionValues',
    TIMESHEET: 'timesheets',
    ENTRY: 'timesheetEntries',
    PAY_PERIOD: 'timeTrackingPayPeriods',
    PAY_SCHEDULE: 'timeTrackingPaySchedules',
    PAYROLL_HOURS_SUMMARY: 'timeTrackingPayrollHoursSummaries',
    REPORT_DOWNLOAD: 'timeTrackingReportDownloads',
    CLOCK_EVENT: 'timeTrackingClockEvents'
  },

  BENEFITS_INVOICE: 'benefitsInvoices',

  ROLE: 'roles',

  COUNTRY: 'countries',
  REGION: 'regions',

  HOLIDAY: 'holidays',

  BILLING: {
    SUBSCRIPTION: 'billingSubscriptionSummary',
    CHARGIFY_DIRECT_PARAMETERS: 'chargifyDirectParameters'
  },

  NOTES: 'notes',

  GLOBAL_SEARCH: 'globalSearch',

  DOCUMENT: 'documents',
  COMPANY_DOCUMENT: 'companyDocuments',
  PENDING_DOCUMENT: 'pendingDocuments',
  DOCUMENT_ACTION: 'documentActions',
  NOTIFICATION_RECIPIENT: 'notificationRecipients',
  ASSIGNMENT_RULE: 'assignmentRules',
  COMPANY_DOCUMENT_ASSIGNMENT: 'companyDocumentAssignments',
  COMPANY_SIGNATURE: 'signatures',
  TAX_DOCUMENT_ASSIGNMENT: 'taxDocumentAssignments',

  REMINDER: 'reminderRules',

  COMPANY_INSURANCE_CARRIER: 'companyInsuranceCarriers',
  ENROLMENT_SUMMARY: 'enrolmentSummaries',

  BENEFIT_INFO: 'benefitInfos',

  EMAIL_TEMPLATE: 'emailTemplates',

  INTERVIEW_GUIDE: 'interviewGuides',
  INTERVIEW_GUIDE_QUESTION: 'interviewGuideQuestions',
  INTERVIEW_INVITE: 'interviewInvites',
  INTERVIEW_SCHEDULE: 'interviewSchedules',

  OFFER_TEMPLATE: 'offerTemplates',
  OFFER_TEMPLATE_SUMMARY: 'offerTemplateSummaries',
  OFFER: 'offers',
  OFFER_SUMMARY: 'offerSummaries',

  USER_DETAIL: 'userDetails',

  PAYROLL_UPLOAD: 'payrollUploads',
  PAYROLL_UPDATE: 'payrollUpdates',
  PAYROLL_EMPLOYEE_SUMMARY: 'payrollEmployeeSummary',
  PAYROLL_DIFF: 'payrollDiffs',

  CUSTOM_REPORT: 'customReports',

  REPORT_DOWNLOAD: 'reportDownloads',

  PAY_PERIOD: 'payPeriods',

  ANNOUNCEMENT: 'announcements',
  ANNOUNCEMENT_COMMENT: 'announcementComments',
  ANNOUNCEMENT_REACTION: 'announcementReactions',
  EMPLOYEE_ANNOUNCEMENT: 'employeeAnnouncements',

  PERFORMANCE_GOALS: {
    GOAL: 'goals',
    EMPLOYEE_DIRECTORY: 'employeeGoalDirectories',
    METRIC: 'metrics',
    TIMELINE: {
      COMMENT: 'goalComments',
      CURRENT_VALUE_UPDATE: 'currentValueUpdates',
      GOAL_CREATED: 'goalCreated',
    }
  },

  PERFORMANCE_REVIEWS: {
    CYCLE: 'reviewCycles',
    REVIEW: 'reviewReviews',
    REVIEWEE: 'reviewReviewees',
    TYPE: 'reviewTypes',
    ANSWER: 'reviewAnswers',
    QUESTION: 'reviewQuestions',
    QUESTION_WITH_TYPE: 'reviewQuestionsWithType',
    TEMPLATE: 'reviewTemplates',
    NOTE: 'reviewNotes',
    RESULT: 'reviewCycleResults',
  },

  SURVEYS: {
    SURVEY: 'surveys',
    RESPONSE: 'surveyResponses',
    ANSWER: 'surveyAnswers',
    QUESTION: 'surveyQuestions',
    EMPLOYEE_STATUS: 'surveyEmployeeStatuses',
    RESULT: 'surveyResults',
  },

  NAVIGATION_SCOPE: 'tabBars',

  BENEFIT_CLASS: 'benefitClasses',
  BENEFIT_DIVISION: 'benefitDivisions',
  GROUP_BENEFIT_COVERAGE: 'groupBenefitCoverages',
  EMPLOYEE_BENEFIT_ENROLLMENT: 'employeeBenefitEnrollments',
  EMPLOYEE_COVERAGE: 'employeeCoverages',

  BENEFITS: {
    UPDATE: 'benefitUpdates',
    BENEFIT_INFO_CHANGE_REQUEST: 'benefitInfoChangeRequests'
  },

  CALENDAR: 'calendars',
  EMPLOYEE_CALENDAR: 'employeeCalendars',
  SEGMENT_CALENDAR: 'segmentCalendars',
  CALENDAR_SUBSCRIPTION: 'calendarSubscriptions',

  LEAVE_TYPE: 'leaveTypes',

  INTEGRATIONS: {
    EXTERNAL_CANDIDATE: 'externalCandidates',
    EXTERNAL_CANDIDATES_SYNC_STATUS: 'externalCandidatesSyncStatuses'
  },

  HR_DASHBOARD: {
    STAFF_COUNTS: 'hrDashboardStaffCounts',
    WIDGET_LAYOUT: 'hrDashboardWidgetLayouts',
    INSIGHTS: {
      INBOX_SUMMARY: 'hrDashboardInsightsInbox',
      PTO_SUMMARY: 'hrDashboardInsightsPTO',
      JOB_APPLICANT_SUMMARY: 'hrDashboardInsightsJobApplicants',
      NEW_HIRE_SUMMARY: 'hrDashboardInsightsNewHires'
    }
  },

  EMPLOYEE_GROUP: 'employeeGroups',

  ATTACHED_DOCUMENT: 'attachedDocuments',

  USER_INVITATION: 'userInvitations',

  ADMIN_INVITATION: 'adminInvitations',

  INVITATION_VALIDATION: 'invitationValidations',

  AUTHENTICATION_RESULT: 'authenticationResults',

  DRAFT: 'drafts',

  MASS_UPDATE: 'massUpdates',
  MASS_UPDATE_SUMMARY: 'massUpdateSummary',
  MASS_UPDATE_EMPLOYEE: 'massUpdateEmployee',
  SSO: {
    OKTA_CREDENTIALS: 'oktaCredentials',
    GOOGLE_CREDENTIALS: 'googleCredentials',
    MICROSOFT_CREDENTIALS: 'microsoftCredentials'
  },

  NMBR: {
    BUSINESS_ENTITY: 'nmbrBusinessEntities',
    EMPLOYEE: 'nmbrEmployees',
    PAY_SCHEDULE: 'nmbrPaySchedules',
    PAYROLL: 'nmbrPayrolls',
    PAY_STUB: 'nmbrPayStubs',
    TAX_DOCUMENT: 'nmbrTaxDocuments',
    UPDATE: 'nmbrUpdates'
  },

  CALENDAR_EVENT: 'calendarEvents',
  CUSTOM_CALENDAR_EVENT: 'customCalendarEvents',

  USER_API_KEY: 'userApiKeys',

  AI_SCREENER_PROMPT: 'aiScreenerPrompts',
  AI_SCREENER_CANDIDATE: 'aiScreenerCandidates',

  EXPENSES: {
    POLICY: 'expensePolicies',
    APPROVER: 'expensePolicyApprovers',
    REQUEST: 'expenseRequests',
    EXPENSE: 'expenses'
  }
};

export default types;
